/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_TitleInputs */

const en_settings_credits_title = /** @type {(inputs: Settings_Credits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

const zh_settings_credits_title = /** @type {(inputs: Settings_Credits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`额度明细`)
};

/**
* | output |
* | --- |
* | "Credits" |
*
* @param {Settings_Credits_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_credits_title = /** @type {((inputs?: Settings_Credits_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_credits_title(inputs)
	return zh_settings_credits_title(inputs)
});
export { settings_credits_title as "settings.credits.title" }